<template>
  <!-- eslint-disable -->
  <!--prettier-ignore-->
  <div v-if="address" class="info-postcode">
    <div class="info-postcode-title">{{ address.receiverName }}</div>
    <div>
      <p>〒 {{ address.zipcode }}</p>
      <p>{{ address.prefecture }}</p>
      <dot :msg="address.address" :line="2" class="desc"></dot>
    </div>
    <div class="mt-20">
      <button
        :disabled="isDisabled"
        class="button is-primary selectB"
        @click="selectDeliveryAddress(itemIndex)"
      >
        この住所に届ける
      </button>
    </div>
    <div class="mt-20">
      <nav class="level">
        <!-- Left side -->
        <div class="level-left">
          <div class="level-item">
            <button
              class="button editB"
              @click="selectDeliveryAddress(itemIndex, 'toEdit')"
            >
              編集
            </button>
          </div>
        </div>
        <!-- Right side -->
        <div class="level-right">
          <div class="level-item">
            <button class="button deleteB" @click="removeAddress(address.id)">
              削除
            </button>
          </div>
        </div>
      </nav>
    </div>
  </div>
  <!--eslint-enable-->
  <!--prettier-enable-->
</template>
<style>
.info-postcode {
  border: 1px solid #9b9b9b;
  padding: 15px;
}
.info-postcode-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}
.button.is-primary.selectB {
  width: 100%;
}
.desc {
  height: 40px;
}
.editB,
.deleteB {
  width: 100px;
}
</style>

<script>
import dot from 'vue-text-dot';

export default {
  name: 'AddressInfo',
  components: { dot },
  props: {
    address: {
      type: Object,
      default: () => {}
    },
    itemIndex: {
      type: Number,
      default: null
    },
    removeAddress: {
      type: Function,
      default: () => {}
    },
    selectDeliveryAddress: {
      type: Function,
      default: () => {}
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      moreText: true
    };
  }
};
</script>
